<template>
  <popup-dialog
    :visible="visible"
    :title="$t('labels.imprint')"
    :close-button-visible="true"
    @close="hideImprint()"
  >
    <imprint-content class="imprint-popup" />
  </popup-dialog>
</template>

<script setup lang="ts">
import PopupDialog from "@core/ui/PopupDialog.vue";
import ImprintContent from "@core/imprint/ImprintContent.vue";

import { useImprintPopup } from "./imprintPopup.js";
const { visible, hideImprint } = useImprintPopup();
</script>

<style lang="scss">
.imprint-popup {
  padding: 2rem 2rem;
}
</style>
